export enum FeatureFlags {
  NEW_DR_SCRIPT = 'new-dr-script',
  DR_EXHIBITS = 'DRExhibits',
  CR_EXHIBITS = 'cr-exhibits',
  CR_AVAILABILITY = 'cr-availability',
}
